import { createContext } from 'react';
import type { Locale } from '@/api/types';

export type Dir = 'ltr' | 'rtl';

export interface I18nContextValue {
  locale: Locale;
  /** Writing direction for the active locale ('rtl' for Arabic). */
  dir: Dir;
  setLocale: (l: Locale) => void;
  /** Translate a dotted key with optional `{var}` interpolation. Falls back en → key. */
  t: (key: string, vars?: Record<string, string | number>) => string;
  /** BCP-47 tag for Intl APIs (dates, numbers). */
  localeTag: string;
}

export const I18nContext = createContext<I18nContextValue | null>(null);

export const SUPPORTED_LOCALES: Locale[] = ['en', 'hi', 'ar'];
export const RTL_LOCALES: Locale[] = ['ar'];
export const LOCALE_TAG: Record<Locale, string> = { en: 'en', hi: 'hi-IN', ar: 'ar' };
